import baseApi from "../utils/baseApi";
import { Admin, CreateSpace, Space } from "../types/spaceTypes";

const userData = JSON.parse(localStorage.getItem("user") || "{}");
const userId = userData?.id;
const userRole = userData?.role;

const SPACES_API = `/${userRole}/spaces`;
const ADMIN_API = "/superadmin/admin";

const formatPhoneNumber = (countryCode: string, phone: string): string => {
    return `${countryCode} ${phone}`.trim(); 
};

export const getSpaces = async (type?: string): Promise<Space[]> => {
    try {
        const query = type ? `?type=${type}` : '';
        const response = await baseApi.get(`${SPACES_API}/list${query}`);

        return response.data.map((space: any) => ({
            id: space.id,
            space_name: space.space_name,
            space_type: space.space_type,
            owner_id: space.owner_id,
            created_at: new Date(space.created_at).toISOString().split("T")[0],
            updated_at: new Date(space.updated_at).toISOString().split("T")[0],
        }));
    } catch (error) {
        throw new Error("Failed to fetch spaces.");
    }
};

export const addSpace = async (spaceData: Partial<CreateSpace>) => {
    try {
        const response = await baseApi.post(SPACES_API, spaceData);
        return response.data;
    } catch (error) {
        throw new Error("Failed to add spaces.");
    }
};

export const updateSpace = async (spaceId: number, spaceData: Partial<Space>) => {
    try {
        const response = await baseApi.put(`${SPACES_API}/${spaceId}`, spaceData);
        return response.data;
    } catch (error) {
        throw new Error("Failed to update space.");
    }
};

export const removeSpace = async (spaceId: number) => {
    try {
        const response = await baseApi.delete(`${SPACES_API}/${spaceId}`);
        return response.data;
    } catch {
        throw new Error("Failed to delete space")
    }
}

export const getAdmins = async(): Promise<Admin[]> => {
    try {
        const response = await baseApi.get(`${ADMIN_API}/list`);

        return response.data.map((admin: any) => ({
            id: admin.id,
            uid: admin.uid,
            name: admin.name,
            username: admin.username,
            email: admin.email,
            address: admin.address,
            phone: formatPhoneNumber(admin.country_code, admin.phone),
            country_code: admin.country_code,
            role: admin.role,
            status: admin.status,
            created_at: new Date(admin.created_at).toISOString().split("T")[0],
            updated_at: new Date(admin.updated_at).toISOString().split("T")[0],
        }))
    }  catch (error) {
        throw new Error("Failed to fetch admins.");
    }
}
